import apiClient from './api-client';

const pacientesService = {
    listar: async () => {
        try {
          const response = await apiClient.get('/pacientes');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get(`/pacientes/${id}`);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      inserir: async (data) => {
        try {
          const response = await apiClient.post('/pacientes', data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      atualizar: async (id, data) => {
        try {
          console.log("id", id)
          const response = await apiClient.patch(`/pacientes/${id}`, data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.Message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      }
}

export default pacientesService;